import {Localizer} from "../../../infrastructure/localization/localizer";
import React from "react";
import {EmblaIcon} from "../../../core/components/emblaIcon/emblaIcon";
import {EmblaIcons} from "../../../core/emblaIcons";
import {RoutePaths} from "../../../infrastructure/routes";
import {useHistory} from "react-router-dom";

type VejlederCellProps = {
    vejledernames: string[];
}
export const VejlederCell = ({vejledernames}: VejlederCellProps) => {
    const history = useHistory();

    const shouldShowBadge = vejledernames.length === 0 || 
        (vejledernames.length === 1 && vejledernames[0] === Localizer.dashboard_tildelVejleder());

    return (
        <>
            {!shouldShowBadge ?
                <div className="max-w-200 word-wrap">
                    {vejledernames.join(", ")}
                </div>
                :
                <div
                    className="flex-align-c badge badge-danger-light badge-pill padding-xs clickable"
                    onClick={() => history.push(RoutePaths.Vejledere.url)}>
                    <div className={"flex-center margin-right-xs"}>
                        <EmblaIcon iconName={EmblaIcons.Danger} additionalClasses={"margin-right-xs danger"}
                                   size={"medium"}/>
                        <b className={"danger-dark"}>
                            {Localizer.dashboard_tildelVejleder()}
                        </b>
                    </div>
                </div>
            }
        </>
    );
};
